
















































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GuestReservations extends Vue {
  @Prop({ default: [] }) private reservations!: Array<any>;

  mounted() {}
}
